// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__i1Z8E","EstimateHeaderTitle":"Page_EstimateHeaderTitle__6CCNd"};